<template>
  <v-container>
    <v-form ref="form" v-model="valid" @submit.prevent="verificarDataParcelas">
      <v-list class="pa-0" two-line>
        <v-toolbar height="56" color="primary">
          <v-toolbar-title class="subheading white--text">
            Cotação de Endosso
          </v-toolbar-title>
        </v-toolbar>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-card class="pa-2" v-show="endosso.idTipoEndosso !== undefined">
          <v-layout row wrap>
            <v-flex xs12 sm12 md3 pr-2 text-xs-left v-if="idTipoEndosso != 6">
              <v-card
                style="border: 1px solid #bababa; border-radius: 5px"
                flat
              >
                <v-card-text style="padding: 5px 10px; margin: 0">
                  <b>Cotação Auto-Frota </b>
                  <br />
                  <v-layout align-center>
                    <v-flex
                      xs7
                      style="padding-top: -5px; margin-top: -5px"
                    ></v-flex>
                    <v-flex
                      text-xs-right
                      xs5
                      style="
                        padding-top: -15px;
                        margin-top: -5px;
                        padding: 0px;
                        margin: 0px;
                      "
                    >
                      <v-tooltip bottom color="blue darken-1">
                        <v-btn
                          :disabled="desabilitaBotaoCotacao"
                          style="
                            padding: -20px 0px 0px 0px;
                            margin: -10px 0px 0px 0px;
                          "
                          slot="activator"
                          icon
                          color="transparent"
                          @click.native="gerarCotacaoEndossoPdf"
                        >
                          <v-icon text-xs-right color="#00456e">get_app</v-icon>
                        </v-btn>
                        <div style="text-align: center">Download</div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm12 md3 pr-2 text-xs-left>
              <v-card
                style="border: 1px solid #bababa; border-radius: 5px"
                flat
              >
                <v-card-text style="padding: 5px 10px; margin: 0">
                  <b>Proposta Auto-Frota </b>
                  <br />
                  <v-layout align-center>
                    <v-flex
                      xs7
                      style="padding-top: -5px; margin-top: -5px"
                    ></v-flex>
                    <v-flex
                      text-xs-right
                      xs5
                      style="
                        padding-top: -15px;
                        margin-top: -5px;
                        padding: 0px;
                        margin: 0px;
                      "
                    >
                      <v-tooltip bottom color="blue darken-1">
                        <v-btn
                          style="
                            padding: -20px 0px 0px 0px;
                            margin: -10px 0px 0px 0px;
                          "
                          :disabled="desabilitaBotaoProposta"
                          slot="activator"
                          icon
                          color="transparent"
                          @click.native="gerarPropostaoEndossoPdf"
                        >
                          <v-icon text-xs-right color="#00456e">get_app</v-icon>
                        </v-btn>
                        <div style="text-align: center">Download</div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm12 md3 pr-2 text-xs-left v-if="!desabilitaBoleto">
              <v-card
                style="border: 1px solid #bababa; border-radius: 5px"
                flat
              >
                <v-card-text style="padding: 5px 10px; margin: 0">
                  <b>Boleto Auto-Frota </b>
                  <br />
                  <v-layout align-center>
                    <v-flex
                      xs7
                      style="padding-top: -5px; margin-top: -5px"
                    ></v-flex>
                    <v-flex
                      text-xs-right
                      xs5
                      style="
                       padding-top: -15px;
                        margin-top: -5px;
                        padding: 0px;
                        margin: 0px;
                      "
                    >
                      <v-tooltip bottom color="blue darken-1">
                        <v-btn
                          :disabled="desabilitaBotaoPdfBoleto"
                          style="
                            padding: -20px 0px 0px 0px;
                            margin: -10px 0px 0px 0px;
                          "
                          slot="activator"
                          icon
                          color="transparent"
                          @click.native="gerarEndossoBoleto"
                        >
                          <v-icon text-xs-right color="#00456e">get_app</v-icon>
                        </v-btn>
                        <div style="text-align: center">Download</div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              v-if="endossoCancelamentoSalvo != true"
              xs12
              sm12
              md3
              pr-2
              text-xs-left
            >
              <v-card
                style="border: 1px solid #bababa; border-radius: 5px"
                flat
              >
                <v-card-text style="padding: 5px 10px; margin: 0">
                  <b>Apólice Auto-Frota </b>
                  <br />
                  <v-layout align-center>
                    <v-flex
                      xs7
                      style="padding-top: -5px; margin-top: -5px"
                    ></v-flex>
                    <v-flex
                      text-xs-right
                      xs5
                      style="
                        padding-top: -15px;
                        margin-top: -5px;
                        padding: 0px;
                        margin: 0px;
                      "
                    >
                      <v-tooltip bottom color="blue darken-1">
                        <v-btn
                          :disabled="desabilitaBotaoPdfEndosso"
                          style="
                            padding: -20px 0px 0px 0px;
                            margin: -10px 0px 0px 0px;
                          "
                          slot="activator"
                          icon
                          color="transparent"
                          @click.native="gerarEndossoApolice"
                        >
                          <v-icon text-xs-right color="#00456e">get_app</v-icon>
                        </v-btn>
                        <div style="text-align: center">Download</div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card class="pa-5">
          <v-flex class="py-1"> Dados do Endosso </v-flex>
          <v-layout row wrap pb-3>
            <v-flex xs12>
              <v-text-field
                :value="nomeUsuarioCorretor || ''"
                label="Corretor Responsável Apólice"
                disabled
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="desabilitarSalvamentoAutomatico" row wrap pb-5>
            <v-flex xs12 sm5 md5>
              <v-autocomplete
                v-model="campoCorretorResponsavelEndosso"
                :disabled="camposDisabled"
                item-text="nome"
                item-value="id"
                :items="listaUsuariosResponsavel"
                label="Corretor Responsável do Endosso"
                :rules="regras.notSelected"
              >
                <template v-slot:selection="data">
                  {{ data.item.nome }}
                </template>
                <template v-slot:no-data>
                  <div class="px-4">
                    Nenhum usuário encontrado com esse nome.
                  </div>
                </template>
                <template v-slot:item="data">
                  <v-list-tile-content
                    @click="corretorResponsavelEndossoSet(data.item.id, data.item.nome)"
                  >
                    <v-list-tile-title
                      v-html="data.item.nome"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.email"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md5 >
              <v-autocomplete
                v-model="campoTecnicoResponsavelEndosso"
                :disabled="camposDisabled"
                item-text="nome"
                item-value="id"
                :items="listaTecnicoResponsavelEndosso"
                label="Tecnico Responsável do Endosso"
                :rules="regras.notSelected"
              >
                <template v-slot:selection="data">
                  {{ data.item.nome }}
                </template>
                <template v-slot:no-data>
                  <div class="px-4">
                    Nenhum técnico responsavel do endosso encontrado com esse nome.
                  </div>
                </template>
                <template v-slot:item="data">
                  <v-list-tile-content
                    @click="tecnicoResponsavelEndossoSet(data.item.id, data.item.nome)"
                  >
                    <v-list-tile-title
                      v-html="data.item.nome"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.email"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout v-if="!desabilitarSalvamentoAutomatico" row wrap pb-5>
            <v-flex xs12 sm5 md5>
              <v-autocomplete
                :disabled="camposDisabled"
                v-model="campoCorretorResponsavelEndosso"
                item-text="nome"
                item-value="id"
                :items="listaUsuariosResponsavel"
                label="Corretor Responsável do Endosso"
                :rules="regras.notSelected"
              >
                <template v-slot:selection="data">
                  {{ data.item.nome }}
                </template>
                <template v-slot:no-data>
                  <div class="px-4">
                    Nenhum usuário encontrado com esse nome.
                  </div>
                </template>
                <template v-slot:item="data">
                  <v-list-tile-content
                    @click="salvarCorretorResponsavelEndosso(data.item.id, data.item.nome)"
                  >
                    <v-list-tile-title
                      v-html="data.item.nome"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.email"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md5 >
              <v-autocomplete
                v-model="campoTecnicoResponsavelEndosso"
                :disabled="camposDisabled"
                item-text="nome"
                item-value="id"
                :items="listaTecnicoResponsavelEndosso"
                label="Tecnico Responsável do Endosso"
                :rules="regras.notSelected"
              >
                <template v-slot:selection="data">
                  {{ data.item.nome }}
                </template>
                <template v-slot:no-data>
                  <div class="px-4">
                    Nenhum técnico responsavel do endosso encontrado com esse nome.
                  </div>
                </template>
                <template v-slot:item="data">
                  <v-list-tile-content
                    @click="salvarTecnicoResponsavelEndosso(data.item.id, data.item.nome)"
                  >
                    <v-list-tile-title
                      v-html="data.item.nome"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.email"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-flex class="py-2"></v-flex>
          <v-layout row wrap>
            <v-flex xs12 sm2 md2>
              <v-select
                label="Tipo Seguro"
                :items="apoliceTipoDePropostaList"
                v-model="idTipoDeProposta"
                item-text="titulo"
                item-value="id"
                disabled
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field disabled label="N. Apólice" v-model="apoliceNumero">
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field
                disabled
                label="Cód. da Cotação do Endosso"
                v-model="codigoEndosso"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field
                disabled
                label="N. Proposta"
                v-model="apoliceNumeroProposta"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-layout row wrap>
            <v-flex xs12 sm12 md3>
              <v-menu
                ref="menu"
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textAtualizacao"
                    label="Data da Ultima Atualização"
                    prepend-icon="event"
                    readonly
                    disabled
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateAtualizacao" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm12 md3>
              <v-menu
                ref="menu"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                :min-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textInicio"
                    label="Inicio Data Vigencia"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    :disabled="
                      camposDisabled || endossoCancelamentoSalvo == true
                    "
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateInicio" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm12 md3>
              <v-menu
                ref="menu"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                :min-width="290"
                disabled
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textFim"
                    label="Fim Data Vigencia"
                    prepend-icon="event"
                    readonly
                    disabled
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateFim" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                label="Tipo Endosso"
                :items="tipoEndossoList"
                v-model="idTipoEndosso"
                item-text="titulo"
                item-value="id"
                disabled
              >
              </v-select>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm5 md3>
              <v-text-field
                disabled
                label="Qtd. de dias de vigência"
                v-model="diasVigencia"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md3>
              <v-select
                label="Motivo do Endosso"
                :items="motivoEndossoList"
                v-model="idMotivoEndosso"
                item-text="titulo"
                item-value="id"
                required
                :rules="regras.notNull"
                :disabled="
                  camposDisabled ||
                    endossoCancelamentoSalvo == true ||
                    camposDisabledGatilho
                "
              >
              </v-select>
            </v-flex>

            <v-spacer></v-spacer>
            <v-flex mb-6 class="textblack">
              Breve descricao sobre o Endosso(Texto Livre)

              <v-flex xs12 sm5 md12>
                <v-textarea
                  v-model="textoLivreEndosso"
                  class="textarea"
                  outline
                  required
                  :rules="[regras.length(7500)]"
                  :readonly="camposDisabled || endossoCancelamentoSalvo == true"
                  counter="7500"
                ></v-textarea>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="py-1">Proponente</v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 sm4 md2>
              <v-text-field
                label="Razão Social"
                required
                browser-autocomplete="off"
                :rules="regras.notNull"
                v-model="proponenteRazaoSocial"
                :disabled="camposDisabled || camposDisabledGatilho"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                label="Tipo Pessoa"
                item-text="titulo"
                item-value="id"
                v-model="idTipoPessoa"
                :items="tipoPessoaList"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled || camposDisabledGatilho"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex md2>
              <v-text-field
                :mask="
                  this.idTipoPessoa === 1
                    ? '###.###.###-##'
                    : 'NN.NNN.NNN/NNNN-##'
                "
                :label="{ 1: 'CPF', 2: 'CNPJ' }[idTipoPessoa] || 'CPF/CNPJ'"
                browser-autocomplete="off"
                required
                :rules="regras.notNull"
                v-model="proponenteCnpj"
                :disabled="
                  !idTipoPessoa || camposDisabled || camposDisabledGatilho
                "
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout v-if="endossoCancelamentoSalvo != true" row>
            <v-flex
              xs6
              md3
              v-if="!camposDisabledGatilho"
              class="checkbox-calculo-itens d-flex"
            >
              <v-checkbox
                style="font-size: 14px; width: 58%"
                v-model="naoCalcularItens"
                class="pa-0 ma-0"
                :disabled="camposDisabled"
                label="Correção de itens barrados pelo enquadrameto Essor"
                v-if="this.idTipoEndosso !== 6"
              ></v-checkbox>
              <v-icon
                @mouseover="activeInfo = true"
                @mouseleave="activeInfo = false"
                class="btn-info-helper"
                dark
                v-if="this.idTipoEndosso !== 6"
                :disabled="camposDisabled"
                >help_circle</v-icon
              >
              <div v-show="activeInfo" class="wrapper-bolha-info">
                <div class="triangle"></div>
                <p class="ma-0">
                  Ao marcar esta opção, então não será efetuado o cálculo dos
                  itens ao emitir. <br />
                  Recomendamos que use este recurso apenas quando estiver
                  realizando o ajuste de ítens barrados pelo enquadramento da
                  Essor.
                </p>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card
          v-if="this.idTipoEndosso === 5 || this.idTipoEndosso === 6"
          class="pa-5"
        >
          <v-flex class="py-4"> Endereço </v-flex>
          <v-layout row wrap pb-4>
            <v-flex xs12 sm4 md2>
              <v-text-field
                mask="##.###-###"
                label="CEP"
                required
                browser-autocomplete="off"
                v-model="apoliceEndereco.enderecoCep"
                :rules="[...regras.notNull, ...regras.cep]"
                :disabled="camposDisabledGatilho || camposDisabled"

              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm4 md3>
              <v-text-field
                label="Rua"
                browser-autocomplete="off"
                required
                :disabled="camposDisabledGatilho || camposDisabled"

                v-model="apoliceEndereco.enderecoRua"
                :rules="regras.notNull"
              >
              </v-text-field>
            </v-flex>

            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md1>
              <v-text-field
                label="Número"
                browser-autocomplete="off"
                required
                :disabled="camposDisabledGatilho || camposDisabled"

                :rules="regras.notNull"
                v-model="apoliceEndereco.enderecoNumero"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md1>
              <v-text-field
                label="Complemento"
                browser-autocomplete="off"
                required
                :rules="regras.notNull"
                :disabled="camposDisabledGatilho || camposDisabled"

                v-model="apoliceEndereco.enderecoComplemento"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field
                label="Bairro"
                browser-autocomplete="off"
                required
                :rules="regras.notNull"
                :disabled="camposDisabledGatilho || camposDisabled"

                v-model="apoliceEndereco.enderecoBairro"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field
                label="Cidade"
                browser-autocomplete="off"
                required
                :disabled="camposDisabledGatilho || camposDisabled"

                :rules="
                  formRulesComputed.endereco.cidade(
                    apoliceEndereco.enderecoCidade,
                    true
                  )
                "
                v-model="apoliceEndereco.enderecoCidade"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md1>
              <v-select
                label="UF"
                browser-autocomplete="off"
                required
                item-text="titulo"
                :disabled="camposDisabledGatilho || camposDisabled"
                item-value="id"
                :items="enderecoUfList"
                v-model="apoliceEndereco.enderecoUf"
                :rules="regras.notNull"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md2>
              <v-text-field
                mask="(##) #####-####"
                label="Telefone (com DDD)"
                :disabled="camposDisabledGatilho || camposDisabled"
                browser-autocomplete="off"
                required
                :rules="
                  formRulesComputed.telefone.numero(
                    apoliceEndereco.enderecoTelefone,
                    true
                  )
                "
                v-model="apoliceEndereco.enderecoTelefone"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field
                label="Email"
                browser-autocomplete="off"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
                v-model="apoliceEndereco.enderecoEmail"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
        </v-card>
        <v-card class="pa-5" v-if="this.idTipoEndosso !== 6">
          <v-flex class="py-2"> Cálculo </v-flex>
          <v-layout row wrap v-if="endossoCancelamentoSalvo != true">
            <v-flex xs12 sm2 md2>
              <v-text-field
                type="number"
                v-model="valorCorretagem"
                label="Comissão (%)"
                required
                disabled
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md2>
              <v-text-field
                type="number"
                v-model="valorApoliceIof"
                label="IOF (%)"
                disabled
              >
              </v-text-field>
            </v-flex>
            <v-flex v-if="camposDisabledGatilho" xs12 sm2 md2>
              <v-text-field
                :value="
                  formatMoney(dadosGatilhoEndosso.valorTotalComercialRetido)
                "
                label="Premio Total Retido Sem IOF"
                disabled
              >
              </v-text-field>
            </v-flex>

            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md2>
              <v-text-field
                v-if="!camposDisabledGatilho"
                type="number"
                v-model="premioTotalEndosso"
                label="Prêmio Total do Endosso (R$)"
                disabled
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md2>
              <v-text-field
                v-if="!camposDisabledGatilho"
                type="number"
                v-model="valorRestituicao"
                label="Valor da Restituição (R$)"
                disabled
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>

            <v-flex xs12 sm2 md2 v-if="!camposDisabledGatilho">
              <v-text-field
                v-if="totalRestituicao > 0"
                label="Total Restituição (R$)"
                :value="totalRestituicao"
                required
                disabled
              />
              <v-text-field
                v-else
                label="Prêmio Total (R$)"
                :value="totalPremio"
                required
                disabled
              />
            </v-flex>
            <v-spacer></v-spacer>
            <v-layout row wrap v-if="camposDisabledGatilho">
              <v-flex xs12 sm2 md2>
                <v-text-field
                  type="number"
                  v-model="dadosGatilhoEndosso.gatilhoEstipulado"
                  label="Gatilho Disponivel (%) "
                  disabled
                >
                </v-text-field>
              </v-flex>

              <v-flex class="ml-4" xs12 sm2 md2>
                <v-text-field
                  type="number"
                  v-model="dadosGatilhoEndosso.sinistralidadePermissivel"
                  label="Sinistralidade Permissivel (%)"
                  disabled
                >
                </v-text-field>
              </v-flex>
              <v-flex class="ml-4" xs12 sm2 md2>
                <v-select
                  label="Gatilho Utilizado (%)"
                  :items="gatilhoUtilizadoList"
                  v-model="dadosGatilhoEndosso.idGatilhoUtilizado"
                  item-text="titulo"
                  item-value="id"
                  required
                  :rules="regras.notNull"
                  :disabled="camposDisabled"
                >
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm3 md3 v-if="idTipoEndosso != 3">
                <v-select
                  label="Qtd. de Parcelas"
                  :items="parcelamentoList"
                  v-model="idParcelamento"
                  item-text="titulo"
                  item-value="id"
                  required
                  :rules="regras.notNull"
                  :disabled="camposDisabled"
                  :error="endossoPendente()"
                >
                </v-select>
              </v-flex>

              <v-spacer></v-spacer>
              <v-flex xs12 sm7 md3 v-if="idTipoEndosso != 3">
                <v-select
                  :items="formaPagamentoList"
                  label="Formas de Pagamento"
                  v-model="idFormaPagamento"
                  item-text="titulo"
                  item-value="id"
                  required
                  :rules="regras.notNull"
                  :disabled="camposDisabled"
                  :error="endossoPendente()"
                >
                </v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm4 md4 v-if="idTipoEndosso != 3">
                <v-menu
                  ref="menu"
                  v-model="menu4"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      label="Data da Primeira Parcela"
                      v-model="textPrimeiraParcela"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      :rules="regras.notNull"
                      :disabled="camposDisabled"
                      :error="endossoPendente()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dataPrimeiraParcela"
                    no-title
                    scrollable
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-layout v-if="endossoPendente()" row wrap>
                <v-flex style="color: red;"> * Dados provisórios, favor revisar </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex
                  v-if="this.idTipoEndosso === 5"
                  xs12
                  sm2
                  md2
                >
                  <v-select
                    label="Condição comercial"
                    :items="tipoCondicaoList"
                    v-model="idTipoCondicao"
                    item-text="titulo"
                    item-value="id"
                    required
                    :rules="regras.notNull"
                    :disabled="camposDisabled || this.listaCondicaoComercialEspecial.length > 0"
                  >
                  </v-select>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex
                  v-if="this.idTipoEndosso === 5"
                  xs12
                  sm2
                  md2
                >
                  <v-select
                    label="Aplic. da Condição"
                    :items="aplicCondicaoList"
                    v-model="idAplicaCondicao"
                    item-text="titulo"
                    item-value="id"
                    required
                    :rules="idTipoCondicao !== 1 ? regras.notNull : []"
                    :disabled="idTipoCondicao === 1 || camposDisabled"
                  >
                  </v-select>
                </v-flex>
                <v-spacer></v-spacer>

                <v-flex
                  v-if="this.idTipoEndosso === 5"
                  xs12
                  sm2
                  md3
                >
                  <v-text-field
                    type="number"
                    label="Perc. da Condição (%)"
                    v-model.number="percCondicaoComercial"
                    :rules="idTipoCondicao !== 1 ? regras.validarNumero : []"
                    :disabled="idTipoCondicao === 1 || camposDisabled"
                  >
                  </v-text-field>
                </v-flex>
                <v-spacer></v-spacer>

                <v-flex>
                  <v-btn
                    class="button-custom"
                    @click="dialogParticipantes = true"
                    flat
                  >
                    participantes
                  </v-btn>
                </v-flex>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
              </v-layout>
            </v-layout>
          </v-layout>
          <v-layout row wrap v-if="endossoCancelamentoSalvo">
            <v-flex xs12 sm2 md2>
              <v-text-field
                v-if="!camposDisabledGatilho"
                label="Total Restituição (R$)"
                :value="totalRestituicao"
                required
                disabled
              />
            </v-flex>
          </v-layout>
        </v-card>
      </v-list>
      <v-layout pt-5>
        <v-flex>
          <v-btn
            color="primary"
            @click="
              $router.push(
                '/GridPrincipal/InfoGerais/GridEndossos?id=' + idApolice + '&idPropostaStatus=' + idPropostaStatus
              )
            "
            flat
          >
            Voltar
          </v-btn>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex>
          <v-btn
            v-if="endossoCancelamentoSalvo"
            class="primary"
            :disabled="totalRestituicao === null || totalRestituicao <= 0"
            @click="modalEmitirCancelamento = true"
          >
            Emitir
          </v-btn>
          <div v-if="camposDisabledGatilho">
            <v-btn
              class="secondary"
              @click="abrirModalCalculoGatilho"
              :disabled="!habilitaCalcularGatilho"
            >
              {{ camposDisabled ? "Ver calculo" : "Calcular" }}
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              class="primary"
              v-if="idTipoEndosso != 4"
              :disabled="
                endosso.idTipoEndosso == 4 && endosso.idStatusEndosso >= 3
              "
              type="submit"
            >
              Próximo
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-snackbar
        :timeout="3000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel"
      >
        {{ snackbar.mensagem }}
        <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
    </v-form>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogParticipantes" max-width="1200px">
          <ModalParticipantes
            v-if="dialogParticipantes"
            :dialog="dialogParticipantes"
            @fechar="dialogParticipantes = false"
            :participantes="participanteList"
            :somenteLeitura="true"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog
          persistent
          v-model="modalEmitirCancelamento"
          max-width="500px"
        >
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline" style="color: #FFF"
                >CANCELAMENTO DO ENDOSSO</span
              >
            </v-card-title>
            <v-card-text class="py-5 px-4">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12>
                    <span>
                      Tem certeza que deseja emitir o cancelamento do endosso?
                    </span>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions
              style="
                display: flex;
                justify-content: space-between;
                width: 100%;
                flex-wrap: wrap;"
              class="px-4 pb-5"
            >
              <v-flex md4>
                <v-btn
                  flat
                  color="primary"
                  @click="modalEmitirCancelamento = false"
                >
                  NÃO
                </v-btn>
              </v-flex>
              <v-flex md4>
                <v-btn class="primary" @click="emitirCancelamento">
                  SIM
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialogErrorEmitirCancelamento" max-width="500">
          <v-card class="text-center">
            <v-card-title class="primary">
              <span class="headline" style="color: #FFF"
                >ERRO PARA EMITIR COTAÇÃO</span
              >
            </v-card-title>

            <h3 class="pa-3 text-xs-center">
              {{ errorMessage }}
            </h3>

            <v-card-text>
              <div
                class="color pa-3"
                v-for="(value, key) in errorDetails"
                :key="key"
              >
                <h4>{{ key }}:</h4>
                <span v-for="(message, index) in value" :key="index">
                  {{ message }}
                </span>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary darken-1"
                flat="flat"
                @click="dialogErrorEmitirCancelamento = false"
              >
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-dialog persistent max-width="1200px" v-model="modalCalculoGatilho">
        <v-card class="dialog">
          <v-card-title class="primary">
            <span class="headline">
              CÁLCULO DO ENDOSSO DE GATILHO
            </span>
          </v-card-title>
          <v-card-text class="pb-5 px-4">
            <div grid-list-md>
              <v-layout wrap pb-2>
                <v-flex xs12 sm3 md2>
                  <v-text-field
                    label="Prêmio Total Líquido Retido"
                    :value="
                      formatMoney(dadosGatilhoEndosso.valorTotalComercialRetido)
                    "
                    disabled
                    required
                  >
                  </v-text-field>
                </v-flex>

                <v-flex class="ml-4" xs12 sm3 md2>
                  <v-text-field
                    label="Prêmio Total"
                    :value="
                      formatMoney(
                        dadosGatilhoEndosso.valorTotalComercialRetidoIof
                      )
                    "
                    disabled
                    required
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-2>
                <v-flex xs12 sm4 md2>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Data da Primeira Parcela"
                        v-model="textPrimeiraParcela"
                        prepend-icon="event"
                        :disabled="camposDisabled"
                        readonly
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataPrimeiraParcela"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>

                <v-spacer></v-spacer>
                <v-flex xs12 sm3 md1>
                  <v-select
                    label="Qtd. de Parcelas"
                    v-model="idParcelamento"
                    :items="parcelamentoList"
                    :disabled="camposDisabled"
                    item-text="titulo"
                    item-value="id"
                    required
                  >
                  </v-select>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex class="ml-4" xs12 sm3 md3>
                  <v-select
                    :items="formaPagamentoList"
                    v-model="idFormaPagamento"
                    label="Formas de Pagamento"
                    item-text="titulo"
                    item-value="id"
                    required
                    :disabled="camposDisabled"
                  >
                  </v-select>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12 sm3 md2>
                  <v-text-field
                    v-model="apoliceIof"
                    label="IOF (%)"
                    disabled
                    required
                  >
                  </v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12 sm3 md1>
                  <v-text-field
                    label="Comissão (%)"
                    required
                    disabled
                    v-model="corretagem"
                  >
                  </v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
              </v-layout>
            </div>
          </v-card-text>

          <v-card-actions class="px-4 pb-5">
            <v-btn @click="fecharModalCalculoGatilho" flat color="primary"
              >Voltar</v-btn
            >
            <v-spacer></v-spacer>
            <template >
              <v-btn
                class="button-permanecer"
                @click="salvarGatilho"
                color="primary"
                :disabled="camposDisabled"
              >
                Salvar Endosso
              </v-btn>

              <v-btn
                class="button-permanecer"
                :disabled="camposDisabled"
                @click="emitirEndosso"
                color="primary"
              >
                Emitir Endosso
              </v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>
<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import formRules from "@/helpers/form-rules.js";
import CustomFormat from "@/helpers/custom-format";
import moment from "moment";
import ModalParticipantes from "./ModalParticipantes.vue";
import tipoEndossoEnum from "@/helpers/tipo-endosso-enum.js";
import statusEndossoEnum from "@/helpers/status-endosso-enum.js";
export default {
  name: "InfoEndosso",

  components: {
    ModalParticipantes
  },

  data: () => ({
    valorCorretagem: null,
    valorApoliceIof: null,
    recalcular: false,
    menu: false,
    modalCalculoGatilho: false,
    dadosGatilhoEndosso: {
      iof: null,
      valorTotalComercialRetido: null,
      corretagem: null
    },
    naoCalcularItens: false,
    desabilitaBotaoCotacao: true,
    desabilitaBotoes: false,
    desabilitaBotaoProposta: true,
    desabilitaBotaoPdfBoleto: true,
    desabilitaBotaoPdfEndosso: true,
    disabled: false,
    apolice: { dateFim: null },
    percCondicaoComercial: null,
    dateInicioEndosso: null,
    dateFimEndosso: null,
    endosso: {},
    conteudoPlanilha: [],
    numeroRevisao: null,
    idTipoCondicao: null,
    modalEmitirCancelamento: false,
    valid: false,
    activeInfo: false,
    dataRespostaApolice: null,
    aplicCondicao: null,
    gatilhoUtilizadoList: [
      {id: 1, titulo: "50%"},
      {id: 2, titulo: "100%"}
    ],
    parcelamentoList: [],
    formaPagamentoList: [],
    dialogErrorEmitirCancelamento: null,
    enderecoUfList: [],
    numeroApolice: null,
    errorMessage: null,
    proponenteRazaoSocial: null,
    idAplicaCondicao: null,
    idRelacionado: null,
    codigoEndosso: null,
    inicioVigencia: null,
    textFimVigencia: null,
    textInicioVigencia: null,
    idTipoEndosso: null,
    idMotivoEndosso: null,
    motivoEndossoList: [],
    tipoEndossoList: [],
    idPropostaStatus: null,
    errorDetails: null,
    premioTotalEndosso: 0,
    textoLivreEndosso: null,
    valorRestituicao: 0,
    idTipoDeProposta: null,
    proponenteCnpj: null,
    apoliceTipoDePropostaList: [],
    idApoliceModalidade: null,
    idApolice: null,
    dataPrimeiraParcela: new Date().toISOString().slice(0, 10),
    idGatilhoUtilizado: null,
    idParcelamento: null,
    idFormaPagamento: null,
    razaoSocialCorretor: null,
    cpfCnpjCorretor: null,
    emailCorretor: null,
    telefoneCorretor: null,
    numeroSusepCorretor: null,
    tipoCorretagemList: [],
    tipoCorretagem: null,
    desabilitaBotaoPdfEndossoBoleto: true,
    desabilitaBotaoPdfEndossoApolice: true,
    valorCorretagem: null,
    apoliceNumeroProposta: null,
    apoliceNumero: null,
    apoliceIof: null,
    corretagem: null,
    diasVigencia: null,
    requisisaoEndosso: {},
    totalPremio: 0,
    totalRestituicao: 0,
    valoresQtdParcelas: null,
    desabilitaBotoes: false,
    vigenciaInicioText: null,
    idTipoPessoa: null,
    dialogParticipantes: false,
    vigenciaFimText: null,
    tipoCondicaoList: [
      { id: 1, titulo: "Nenhuma" },
      { id: 2, titulo: "Agravo" },
      { id: 3, titulo: "Desconto" }
    ],
    tipoCondicaoFiltrada: [
      { id: 2, titulo: "Agravo" },
      { id: 3, titulo: " Desconto" }
    ],
    tipoPessoaList: [
      { id: 1, titulo: "Física" },
      { id: 2, titulo: "Jurídica" }
    ],
    aplicCondicaoList: [
      { id: 1, titulo: "Em Todas as coberturas" },
      { id: 2, titulo: "Apenas RCFs" },
      { id: 3, titulo: "Apenas Compreensiva" }
    ],
    participanteList: [],
    apoliceEndereco: {
      enderecoCep: null,
      enderecoRua: null,
      enderecoNumero: null,
      enderecoComplemento: null,
      enderecoBairro: null,
      enderecoCidade: null,
      enderecoUf: null,
      enderecoTelefone: null,
      enderecoEmail: null
    },
    dateAtualizacao: new Date().toISOString().slice(0, 10),
    dateInicio: new Date().toISOString().slice(0, 10),
    dateFim: new Date().toISOString().slice(0, 10),
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    modal: false,
    endossoTipoSubstituicao: false,
    idStatusEndosso: null,
    campoUsuarioReponsavel: null,
    campoCorretorResponsavelEndosso: null,
    idCorretorResponsavelEndosso: null,
    nomeCorretorResponsavelEndosso: null,
    idCorretorResponsavelEndossoFiltrado: null,
    modelCorretorResponsavelEndosso: {
      idCorretorResponsavelEndosso: null,
      nomeCorretorResponsavelEndosso: null,
      tipoEndosso: null,
      idEndosso: null,
    },
    listaUsuariosResponsavel: [],
    idUsuarioCorretor: null,
    nomeUsuarioCorretor: null,
    idUsuarioCorretorFiltrado: null,
    campoTecnicoResponsavelEndosso: null,
    listaTecnicoResponsavelEndosso: [],
    idTecnicoResponsavelEndosso: null,
    nomeTecnicoResponsavelEndosso: null,
    idTecnicoResponsavelEndossoFiltrado: null,
    modelTecnicoResponsavelEndosso: {
      idTecnicoResponsavelEndosso: null,
      nomeTecnicoResponsavelEndosso: null,
      tipoEndosso: null,
    },
    endossoNovo: true,
    desabilitarSalvamentoAutomatico: true,
    modelosListas: {
      catVeiculoList: [],
    },
    mostrarCamposCondicaoComercialEspecial: false,
    listaCondicaoComercialEspecial: [],
    listaCondicaoComercialEspecialModificacao: [],
    regras: {
      minItemCategoriaSelected: [v => v !== null && v.length > 0 || 'Selecione uma Categoria'],
      notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      validarNumero: [v => {
        const notNull = !!v || "Você não pode deixar este campo em branco";
        const numeroValido = !isNaN(v) || "Por favor, insira um valor válido";
        return notNull === true ? numeroValido : notNull;
      }],
      cnpj: [v => !!String(v).match(/^[A-Za-z0-9]{12}\d{2}$/) || "CNPJ incorreto"],
      cep: [v => !!String(v).match(/^\d{8}$/) || "CEP incorreto"],
      length: len => v =>
        (!!v && (v || "").length <= len) ||
        `Preencha esse campo com no máximo ${len} caracteres.`
    },
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    }
  }),
  async mounted() {
    this.buscaOpcoesTipoVeiculo();
    Object.entries(this.$store.getters["formEndosso/infoEndosso"]).forEach(
      ([key, value]) => {
        if (
          (this[key] instanceof Array &&
            value instanceof Array &&
            !this[key].length) ||
          value !== null
        ) {
          this[key] = value;
        }
      }
    );
    this.idStatusEndosso = parseInt(this.$route.query.idStatusEndosso);
    this.idTipoEndosso = parseInt(this.$route.query.idTipoEndosso);
    this.idApolice = this.$route.query.id;
    this.idPropostaStatus = this.$route.query.idPropostaStatus
      ? this.$route.query.idPropostaStatus
      : null;
    this.idRascunhoEndosso = this.$route.query.idRascunhoEndosso;
    this.numeroRevisao = this.$route.query.numeroRevisao;
    if (
      this.idApolice &&
      (this.idTipoEndosso == 5 || this.idTipoEndosso == 6)
    ) {
      this.$store.commit("startLoading");

      this.buscarEndereco();
      this.endossoTipoSubstituicao = true;
      this.$store.commit("endLoading");
    }
    if(
      this.idTipoEndosso != tipoEndossoEnum.tipoEndosso.GATILHO
    ) {
      if (this.idRascunhoEndosso || this.numeroRevisao ) {
        this.dateInicioEndosso = localStorage.getItem("dateInicio");

        this.$store.commit("startLoading");
        await this.buscarApolice();
        await this.buscarEndosso(
          this.idRascunhoEndosso || this.numeroRevisao,
          this.idRascunhoEndosso
        );
        this.$store.commit("formEndosso/setInfoEndosso", {
          ...this.endosso,
          idRascunhoEndosso: this.idRascunhoEndosso,
        });
        Object.entries(this.$store.getters["formEndosso/infoEndosso"]).forEach(
          ([key, value]) => (this[key] = value)
        );
        this.$store.commit("endLoading");
        this.contarDias(
          new Date(localStorage.getItem("dateFim")),
          new Date(this.dateInicio)
        );
      }
    }


    if (this.numeroRevisao == undefined) {
      this.buscarApolice();
    }
    this.retornarTipoDeProposta();
    this.buscaOpcoes();
    this.buscarParticipantes();
    if (this.idTipoEndosso === 5 || this.idTipoEndosso === 6) {
      this.buscarEndereco();
      this.endossoTipoSubstituicao = true;
    }

    if (this.numeroRevisao == undefined) {
      this.retornarTipoPessoa();
      this.retornarProponenteCNPJ();
      this.buscarProponenteRazaoSocial();
    } else {
      this.retornarTipoPessoaEndosso();
      this.buscarProponenteCnpjEndosso();
      this.buscarProponenteRazaoSocialEndosso();
    }

    this.botoesDisabled();
    if (
      this.endosso.codigoEndosso != undefined ||
      this.endosso.codigoEndosso != null
    ) {
      this.getRespostaEndosso();
      if (
        this.endosso.idStatusEndosso ==
        statusEndossoEnum.statusEndosso.ENDOSSO_APROVADO
      ) {
        this.getRespostaPdfEndossoApolice();
        this.getRespostaPdfEndossoBoleto();
      }
    }

    this.endosso.idStatusEndosso >= statusEndossoEnum.statusEndosso.SALVO ||
    this.endosso.idStatusEndosso == null
      ? (this.desabilitaBotaoCotacao = false)
      : (this.desabilitaBotaoCotacao = true);
    if (this.idTipoEndosso == tipoEndossoEnum.tipoEndosso.GATILHO) {
      this.$store.commit("startLoading");
      if (this.idStatusEndosso == statusEndossoEnum.statusEndosso.SALVO) {
        this.buscarEndossoGatilhoSalvo()
      } else if(this.idStatusEndosso >=statusEndossoEnum.statusEndosso.EMITIDA) {
        this.buscarEndossoGatilhoEmitido();
      }else {
        this.idMotivoEndosso = 1;
        this.retornaInfoEndossoGatilho();
      }

      this.$store.commit("endLoading");
    }

    this.buscarUsuariosCampoResponsavel(true);
    this.buscarCampoTecnicosResponsaveisEndosso(true);
    this.verificarDesabilitarSalvamentoAutomatico();
    this.desabilitaBotaoCotacao = this.validarPropostaCotacaoDisabled();
    if (this.numeroRevisao != null && this.numeroRevisao > 0) {
      this.buscarListaEndossoCondicaoEspecial();
    }
  },

  computed: {

    habilitaCalcularGatilho() {
      return (
        this.dadosGatilhoEndosso.valorTotalComercialRetido != null &&
        this.dadosGatilhoEndosso.gatilhoEstipulado != null &&
        this.dadosGatilhoEndosso.idGatilhoUtilizado != null &&
        this.textoLivreEndosso != null &&
        this.idParcelamento != null &&
        this.idFormaPagamento != null
      );
    },
    camposDisabledGatilho() {
      return this.idTipoEndosso == tipoEndossoEnum.tipoEndosso.GATILHO;
    },
    camposDisabled() {
      return (
        ((this.idStatusEndosso > statusEndossoEnum.statusEndosso.SALVO && this.idStatusEndosso != statusEndossoEnum.statusEndosso.PENDENTE) || this.idPropostaStatus == 7)
      );
    },
    endossoCancelamentoSalvo() {
      return (
        this.endosso.idStatusEndosso == statusEndossoEnum.statusEndosso.SALVO && this.endosso.idTipoEndosso== 4
      );
    },
    textAtualizacao() {
      return new Date(this.dateAtualizacao).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    desabilitaBoleto() {
      return this.endosso.idTipoEndosso == 4 || this.endosso.idTipoEndosso == 6;
    },
    condicaoComercial: {
      get() {
        switch (this.idTipoCondicao) {
          case 1:
            return 4;
          case 2:
            if (this.percCondicaoComercial < 0) {
              this.percCondicaoComercial = -this.percCondicaoComercial
            }
            return +this.percCondicaoComercial;
          case 3:
            if (this.percCondicaoComercial < 0) {
              this.percCondicaoComercial = -this.percCondicaoComercial
            }
            return -this.percCondicaoComercial;
        }
      },
      set(perc) {
        if (typeof perc === "number") {
          if (perc === 0) {
            this.idTipoCondicao = this.tipoCondicaoList[0].id;
          } else {
            this.percCondicaoComercial = Math.abs(perc);
            this.idTipoCondicao = this.tipoCondicaoList[perc > 0 ? 1 : 2].id;
          }
        }
      }
    },
    textInicio() {
      return new Date(this.dateInicio).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    textPrimeiraParcela() {
      return new Date(this.dataPrimeiraParcela).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },

    textFim() {
      let data = new Date(this.dateFim).toISOString().slice(0, 10);
      return new Date(data).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },

    formRulesComputed() {
      return formRules;
    }
  },
  watch: {
    listaCondicaoComercialEspecial(newVal) {
      if (newVal.length > 0) {
        this.idTipoCondicao = 1;
        this.idAplicaCondicao = null;
        this.percCondicaoComercial = null;
      }
    },
    idTipoCondicao(newVal) {
      if (newVal == 1) {
        this.idAplicaCondicao = 4;
        this.percCondicaoComercial = 0;
      } else {
        this.idTipoCondicao = newVal;
      }
    },
  },
  methods: {
    endossoPendente() {
      return this.endosso.idStatusEndosso == statusEndossoEnum.statusEndosso.PENDENTE
    },
    validarPropostaCotacaoDisabled() {
      const statusHabilitados = [
        statusEndossoEnum.statusEndosso.SALVO,
        statusEndossoEnum.statusEndosso.EMITIDA,
        statusEndossoEnum.statusEndosso.ENDOSSO_APROVADO,
        statusEndossoEnum.statusEndosso.ENDOSSO_REPROVADO,
        statusEndossoEnum.statusEndosso.CANCELADO,
        statusEndossoEnum.statusEndosso.RECUSADO,
      ];

      return !statusHabilitados.includes(this.endosso.idStatusEndosso);
    },
    buscarEndossoGatilhoSalvo() {
      this.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/visualizarEndossoGatilhoSalvo/${this.numeroRevisao}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          return response.data;
        })
        .then(data => {
          this.$store.commit("formEndosso/setInfoEndosso", {
            ...data,
            idRascunhoEndosso: this.idRascunhoEndosso
          });
          Object.entries(
            this.$store.getters["formEndosso/infoEndosso"]
          ).forEach(([key, value]) => (this[key] = value));
          this.dadosGatilhoEndosso.gatilhoEstipulado = data.gatilhoEstipulado;
          this.dadosGatilhoEndosso.sinistralidadePermissivel = data.sinistralidadePermissivel;
          this.dadosGatilhoEndosso.valorTotalComercialRetido = data.valorTotalComercialRetido;
          this.dadosGatilhoEndosso.valorTotalComercialRetidoIof = data.valorTotalComercialRetidoIof
          this.contarDias(
            new Date(this.dateFim),
            new Date(this.dateInicio)
          );
          this.idTipoDeProposta = 2;
          this.$store.commit("endLoading");
        }).catch(err => {
          this.$store.commit("endLoading");
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },

    buscarEndossoGatilhoEmitido() {
      this.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/visualizarEndossoGatilhoEmitido/${this.idApolice}/${this.numeroRevisao}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          return response.data;
        })
        .then(data => {
          this.$store.commit("formEndosso/setInfoEndosso", {
            ...data,
            idRascunhoEndosso: this.idRascunhoEndosso
          });
          Object.entries(
            this.$store.getters["formEndosso/infoEndosso"]
          ).forEach(([key, value]) => (this[key] = value));
          this.dadosGatilhoEndosso.gatilhoEstipulado = data.gatilhoEstipulado;
          this.dadosGatilhoEndosso.sinistralidadePermissivel = data.sinistralidadePermissivel;
          this.dadosGatilhoEndosso.valorTotalComercialRetido = data.valorTotalComercialRetido;
          this.dadosGatilhoEndosso.valorTotalComercialRetidoIof = data.valorTotalComercialRetidoIof
          this.contarDias(
            new Date(this.dateFim),
            new Date(this.dateInicio)
          );
          this.idTipoDeProposta = 2;
          this.$store.commit("endLoading");
        }).catch(err => {
          this.$store.commit("endLoading");
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },

    montarObjetoGatilho() {
      let objetoGatilho = new Object();
      objetoGatilho.textoLivreEndosso = this.textoLivreEndosso;
      objetoGatilho.idTipoEndosso = this.idTipoEndosso;
      objetoGatilho.idMotivoEndosso = this.idMotivoEndosso;
      objetoGatilho.dataPrimeiraParcela = this.dataPrimeiraParcela;
      objetoGatilho.idFormaPagamento = this.idFormaPagamento;
      objetoGatilho.idParcelamento = this.idParcelamento;
      objetoGatilho.dataInicio = this.dataInicio;
      objetoGatilho.idTipoCondicao = this.idTipoCondicao;
      objetoGatilho.idAplicaCondicao = this.idAplicaCondicao;
      objetoGatilho.percCondicaoComercial = this.percCondicaoComercial;
      objetoGatilho.idTipoPessoa = this.idTipoPessoa;
      objetoGatilho.proponenteCnpj = this.proponenteCnpj;
      objetoGatilho.proponenteRazaoSocial = this.proponenteRazaoSocial;
      objetoGatilho.idGatilhoUtilizado = this.dadosGatilhoEndosso.idGatilhoUtilizado;
      objetoGatilho.valorTotalComercialRetidoIof = this.dadosGatilhoEndosso.valorTotalComercialRetidoIof;
      objetoGatilho.dateInicio  = this.dateInicio;
      objetoGatilho.dateFim = this.dateFim;
      objetoGatilho.idEndossoRascunhoSalvo = this.numeroRevisao;
      return objetoGatilho;
    },

    salvarGatilho() {
      this.$store.commit("startLoading");
      axios
        .post(
          `${process.env.URL_ENDOSSOMS}/v1/salvarEndosso/${this.idApolice}`,
          this.montarObjetoGatilho(),
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.$store.commit("startLoading");

          this.snackbar.visivel = true;
          this.snackbar.sucesso = true;
          this.snackbar.mensagem = "Endosso de Gatilho salvo com sucesso.";
          setTimeout(() => {
            this.$router.push(
              "/GridPrincipal/InfoGerais/GridEndossos?id=" + this.idApolice
            );
          }, 2000);

        })
        .catch(err => {
          this.$store.commit("startLoading");

          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },

    abrirModalCalculoGatilho() {
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/validarDataParcelamento?dataFimPolice=${this.dateFim}&dataInicioParcela=${this.dataPrimeiraParcela}&parcelas=${this.idParcelamento}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response) {
            if (this.dadosGatilhoEndosso.idGatilhoUtilizado === 1) {
              this.dadosGatilhoEndosso.valorTotalComercialRetido = this.dadosGatilhoEndosso.valorTotalComercialRetido / 2;
              this.dadosGatilhoEndosso.valorTotalComercialRetidoIof = this.dadosGatilhoEndosso.valorTotalComercialRetidoIof / 2;
            }
            this.modalCalculoGatilho = true;
          }
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },

    fecharModalCalculoGatilho() {
      if (this.dadosGatilhoEndosso.idGatilhoUtilizado === 1) {
        this.dadosGatilhoEndosso.valorTotalComercialRetido = this.dadosGatilhoEndosso.valorTotalComercialRetido * 2;
        this.dadosGatilhoEndosso.valorTotalComercialRetidoIof = this.dadosGatilhoEndosso.valorTotalComercialRetidoIof * 2;
      }
      this.modalCalculoGatilho = false;
    },

    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(amount || 0);
    },

    retornaInfoEndossoGatilho() {
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/retornarInformaçoesGatilho/${this.idApolice}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          return response.data;
        })
        .then(data => {
          this.dadosGatilhoEndosso = data;
          this.apoliceIof = data.iof;
          this.corretagem = data.corretagem;
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },

    verificarDataParcelas() {
      if ((this.idTipoEndosso == 1 || this.idTipoEndosso == 5) && this.idPropostaStatus !== 7) {
        axios
          .get(
            `${process.env.URL_APOLICEMS}/v1/validarDataParcelamento?dataFimPolice=${this.dateFim}&dataInicioParcela=${this.dataPrimeiraParcela}&parcelas=${this.idParcelamento}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
            }
          )
          .then(response => {
            if (response) {
              this.proximaPagina();
            }
          })
          .catch(err => {
            console.log("err", err)
            this.snackbar.visivel = true;
            this.snackbar.sucesso = false;
            this.snackbar.mensagem = err.response.data.message;
          });
      } else {
        this.proximaPagina();
      }
    },

    emitirCancelamento() {
      this.$store.commit("startLoading");
      axios
        .post(
          `${process.env.URL_ENDOSSOMS}/v1/emitirEndossoCancelamento/${this.numeroRevisao}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = true;
          this.snackbar.mensagem = "Endosso de Cancelamento emitido";
          this.$router.push(
            "/GridPrincipal/InfoGerais/GridEndossos?id=" + this.idApolice
          );
        })
        .catch(error => {
          this.dialogErrorEmitirCancelamento = true;
          if (error.response && error.response.data) {
            this.errorMessage =
              error.response.data.erros || error.response.data.message;
          } else {
            this.errorMessage = error.response.data.message;
          }
        });
      this.$store.commit("endLoading");
    },

    async getRespostaEndosso() {
      const response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/buscarRespostaEndosso/${this.idApolice}/${this.endosso.codigoEndosso}`,

        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      if (
        (this.idTipoEndosso == tipoEndossoEnum.tipoEndosso.SUBSTITUICAO ||
        this.idTipoEndosso == tipoEndossoEnum.tipoEndosso.ALTERACAO) &&
        this.endosso.idStatusEndosso >= statusEndossoEnum.statusEndosso.SALVO
      ) {
        this.desabilitaBotaoProposta = false;
      } else {
        response.data
          ? (this.desabilitaBotaoProposta = false)
          : (this.desabilitaBotaoProposta = true);
      }
      this.idRelacionado = response.data.id_endosso_relacionado;
    },

    async getRespostaPdfEndossoApolice() {
      const response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/gerarEndossoApolice/${this.idApolice}/${this.endosso.codigoEndosso}`,

        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      response.data
        ? (this.desabilitaBotaoPdfEndosso = false)
        : (this.desabilitaBotaoPdfEndosso = true);
    },

    async getRespostaPdfEndossoBoleto() {
      const response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/gerarEndossoBoleto/${this.idApolice}/${this.endosso.codigoEndosso}`,

        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      response.data
        ? (this.desabilitaBotaoPdfBoleto = false)
        : (this.desabilitaBotaoPdfBoleto = true);
    },

    botoesDisabled() {
      return this.endosso.idStatusEndosso ==
        statusEndossoEnum.statusEndosso.ENDOSSO_APROVADO
        ? (this.desabilitaBotoes = false)
        : (this.desabilitaBotoes = true);
    },

    async retornarAplicaCondicao() {
      var response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/retornarAplicaCondicao/${this.numeroRevisao}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idAplicaCondicao = response.data;
    },

    async retornarTipoCondicao() {
      var response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/retornarTipoCondicao/${this.numeroRevisao}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idTipoCondicao = response.data;
    },

    async retornarPercCondicao() {
      var response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/retornarPercCondicao/${this.numeroRevisao}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.percCondicaoComercial = response.data;
    },

    gerarCotacaoEndossoPdf() {
      return axios({
        url: `${process.env.URL_ENDOSSOMS}/v1/gerarEndosso/${this.idApolice}/${
          this.numeroRevisao
            ? this.numeroRevisao
            : this.endosso.idRascunhoEndosso
        }?tipo=${this.idTipoEndosso}&rascunho=${
          this.$route.query.idStatusEndosso ==
          statusEndossoEnum.statusEndosso.SALVO
            ? true
            : false
        }`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });
          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Endosso.pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf cotação não localizado";
        });
    },

    gerarPropostaoEndossoPdf() {
      return axios({
        url: `${process.env.URL_ENDOSSOMS}/v1/gerarEndossoProposta/${this.idApolice}/${this.numeroRevisao}?tipo=${this.idTipoEndosso}`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });
          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Endosso-proposta.pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf proposta não localizado";
        });
    },

    async retornarProponenteCNPJ() {
      var response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/buscarProponenteCnpj/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.proponenteCnpj = response.data;
    },

    async buscarProponenteCnpjEndosso() {
      try {
        const url =
          this.idTipoEndosso == 4
            ? `${process.env.URL_APOLICEMS}/v1/retornarProponenteCnpj/${this.idApolice}`
            : `${process.env.URL_ENDOSSOMS}/v1/buscarProponenteCnpjEndosso/${this.numeroRevisao}?status=${this.idStatusEndosso}`;
        var response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        });
        this.proponenteCnpj = response.data;
      } catch (e) {}
      if (!this.proponenteCnpj) {
        try { await this.retornarProponenteCNPJ(); } catch (e) {}
      }
    },

    async buscarProponenteRazaoSocial() {
      var response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/buscarProponenteRazaoSocial/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.proponenteRazaoSocial = response.data;
    },

    async buscarProponenteRazaoSocialEndosso() {
      try {
        const url =
          this.idTipoEndosso == 4
            ? `${process.env.URL_APOLICEMS}/v1/retornarProponenteRazaoSocial/${this.idApolice}`
            : `${process.env.URL_ENDOSSOMS}/v1/buscarProponenteRazaoSocialEndosso/${this.numeroRevisao}?status=${this.idStatusEndosso}`;
        var response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        });
        this.proponenteRazaoSocial = response.data;
      } catch (e) {}
      if (!this.proponenteRazaoSocial) {
        try { await this.buscarProponenteRazaoSocial(); } catch (e) {}
      }
    },

    async retornarTipoPessoa() {
      var response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarTipoPessoa/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idTipoPessoa = response.data;
    },

    async retornarTipoPessoaEndosso() {
      try {
        const url =
          this.idTipoEndosso == 4
            ? `${process.env.URL_APOLICEMS}/v1/retornarTipoPessoa/${this.idApolice}`
            : `${process.env.URL_ENDOSSOMS}/v1/retornarTipoPessoaEndosso/${this.numeroRevisao}`;
        var response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        });
        this.idTipoPessoa = response.data;
      } catch (e) {}
      if (!this.idTipoPessoa) {
        try { await this.retornarTipoPessoa(); } catch (e) {}
      }
    },

    gerarEndossoApolice() {
      return axios({
        url: `${process.env.URL_ENDOSSOMS}/v1/gerarEndossoApolice/${this.idApolice}/${this.idRelacionado}`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });

          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Apolice-endosso- " + this.apolice.proponenteRazaoSocial + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf Apólice não localizado";
        });
    },

    gerarEndossoBoleto() {
      return axios({
        url: `${process.env.URL_ENDOSSOMS}/v1/gerarEndossoBoleto/${this.idApolice}/${this.idRelacionado}`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });

          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Boleto-endosso- " + this.apolice.proponenteRazaoSocial + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf Boleto não localizado";
        });
    },

    dataFormatada(data) {
      let dateFim = new Date(data).toISOString().slice(0, 10);
      return new Date(dateFim).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },

    verificarDesabilitarSalvamentoAutomatico() {
      if (!this.endossoNovo) {
        this.desabilitarSalvamentoAutomatico = false;
      } else {
        this.desabilitarSalvamentoAutomatico = true;
      }
    },

    async buscarApolice() {
      const response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/buscarApolice/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );

      this.apolice = response.data;
      this.dateFim = this.apolice.dateFim;
      this.apoliceIof = this.apolice.apoliceIof;
      this.valorCorretagem = this.apolice.corretagem;
      this.valorApoliceIof = this.apolice.apoliceIof;
      this.apoliceNumeroProposta = this.apolice.apoliceNumeroProposta;
      this.apoliceNumero = this.apolice.apoliceNumero;
      this.idUsuarioCorretorFiltrado = response.data.idUsuarioCorretor;
      this.idUsuarioCorretor = response.data.idUsuarioCorretor;
      this.nomeUsuarioCorretor = response.data.nomeUsuarioCorretor;
      this.contarDias(
        new Date(this.apolice.dateFim),
        new Date(this.apolice.dateInicio)
      );
    },

    async buscarEndosso(idEndosso, rascunho) {
      const response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/visualizar${this.visualizarEndosso(
          idEndosso,
          rascunho
        )}/${idEndosso}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.endosso = response.data;
      this.endossoCopy = response.data;
      this.textoLivreEndosso = response.data.textoLivreEndosso;
      this.proponenteRazaoSocial = response.data.proponenteRazaoSocial;
      this.percCondicaoComercial = response.data.percCondicaoComercial;
      if(response.data.proponenteRazaoSocial == null) {
        this.buscarEndereco();
      }

      this.dateInicio = this.endosso.dateInicio;
      this.dateFim = this.endosso.dateFim;
      this.idUsuarioCorretorFiltrado = response.data.idUsuarioCorretor;
      this.idTecnicoResponsavelEndossoFiltrado = response.data.idTecnicoResponsavelEndosso;
      this.idCorretorResponsavelEndosso = response.data.idCorretorResponsavelEndosso;
      this.nomeCorretorResponsavelEndosso = response.data.nomeCorretorResponsavelEndosso;
      this.idCorretorResponsavelEndossoFiltrado = response.data.idCorretorResponsavelEndosso;
      this.campoCorretorResponsavelEndosso = response.data.idCorretorResponsavelEndosso;
      this.endossoNovo = false;
    },

    visualizarEndosso(idEndosso, rascunho) {
      if (rascunho) {
        return "RascunhoEndosso";
      } else if (
        idEndosso &&
        (this.idStatusEndosso == statusEndossoEnum.statusEndosso.SALVO || this.idStatusEndosso == statusEndossoEnum.statusEndosso.PENDENTE ) &&
        this.idTipoEndosso != 4
      ) {
        return "EndossoSalvo";
      } else {
        return "Endosso";
      }
    },

    async buscarEndereco() {
      const response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/buscarEndereco/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.apoliceEndereco = response.data;
    },

    toLocalDateTimeString: function(val) {
      var data = CustomFormat.toLocaleDateTimeString(val);
      return data.slice(0, 10);
    },

    formatDate() {
      if (this.dataRespostaApolice) {
        var formatedDate = moment(this.dataRespostaApolice).format(
          "DD/MM/YYYY"
        );
        return formatedDate;
      }
    },

    contarDias(dateFim, dataInicio) {
      let dias = 1000 * 60 * 60 * 24;
      let inicio = dataInicio.getTime();
      let fim = dateFim.getTime();
      let diasCalculo = Math.abs(fim - inicio);
      this.diasVigencia = Math.round(diasCalculo / dias);
    },

    async retornarTipoDeProposta() {
      var response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarTipoDeProposta/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idTipoDeProposta = response.data;
    },

    async buscarParticipantes() {
      var response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/listarParticipantes/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.participanteList = response.data;
    },

    buscaOpcoes() {
      [
        "propostaStatus",
        "propostaTipo",
        "apoliceTipoDeProposta",
        "apoliceModalidade",
        "parcelamento",
        "formaPagamento",
        "proponenteRamoDeAtuacao",
        "enderecoUf",
        "motivoEndosso",
        "tipoEndosso"
      ].forEach(item => {
        axios
          .get(`${process.env.URL_APOLICEMS}/v1/${item}`, {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          })
          .then(response => {
            this[`${item}List`] =
              response.data instanceof Array ? response.data : [];
          })
          .catch(err => {
            console.error(err);
          });
      });
    },

    onDateChange: function() {
      const self = this;
      const date = self.dateInicio.split("-");
      const ano = parseInt(date[0]) + 1;
      const newDateFim = date.concat(ano + "-" + date[1] + "-" + date[2]);
      this.dateFim = newDateFim[3];
    },

    dadosLocalStore() {
      var dadosEndosso = {
        idMotivoEndosso: this.idMotivoEndosso,
        textoLivreEndosso: this.textoLivreEndosso,
        idTipoEndosso: this.idTipoEndosso,
        idApolice: this.idApolice,
        itemRemovidoList: this.itemRemovidoList,
        dateInicio: this.dateInicio
      };
    },

    emitirEndosso() {
      this.$store.commit("startLoading")
      axios.post(`${process.env.URL_ENDOSSOMS}/v1/emitirEndosso/${this.idApolice}`, this.montarObjetoGatilho(),
      {
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      }).then(response => {
        return response.data;
      }).then((data) => {
          this.$store.commit("endLoading")
          this.snackbar.visivel = true;
          this.snackbar.sucesso = true;
          this.snackbar.mensagem = "Endosso de Gatilho emitido com sucesso.";
          setTimeout(() => {
            this.$router.push(
              "/GridPrincipal/InfoGerais/GridEndossos?id=" + this.idApolice
            );
          }, 2000);

      }).catch(err => {
          this.$store.commit("endLoading")
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;

        });

    },

    validarRecalcular: function() {
      if(this.endosso != null) {
          this.recalcular = this.endosso.dateInicio !== this.dateInicio ||
          this.endosso.idParcelamento !== this.idParcelamento ||
          this.endosso.dataPrimeiraParcela !== this.dataPrimeiraParcela ||
          this.endosso.percCondicaoComercial !== this.condicaoComercial ||
          this.endosso.idTipoCondicao !== this.idTipoCondicao ||
          this.endosso.idAplicaCondicao !== this.idAplicaCondicao
          ;

      } else {
        this.recalcular = false
      }
    },

    proximaPagina: function() {
      if (this.$refs.form.validate()) {
        this.validarRecalcular();
        this.atualizarInformacoesEndosso();
        this.redirecionarPagina();
      } else if (this.idPropostaStatus == 7) {
        this.redirecionarPagina();
      }
    },

    tratamentoCampoUsuarioResponsavel(idUsuario, response) {
      if (idUsuario != null) {
        if (idUsuario == 0) {
          this.usuarioApisul = {
            id: 0,
            nome: "GRUPO APISUL",
            email: "grupo@apisul.com"
          };
        } else {
          this.listaUsuariosResponsavel = response;
          this.buscarUsuarioId(idUsuario);
        }
      }
    },

    buscarUsuarioId(id) {
      axios
        .get(
          `${process.env.URL_USUARIOMS}/v1/no-auth/buscaUsuarioSimplesPorId?id=${id}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response) {
            this.listaUsuariosResponsavel.push(response.data);
            this.campoUsuarioReponsavel = id;
            this.idUsuarioCorretor = id;
            this.nomeUsuarioCorretor = response.data.nome;
          }
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },

    tratamentoCampoTecnicoResponsavelEndosso(idTecnicoResponsavelEndosso, response) {
      if (idTecnicoResponsavelEndosso != null) {
        if (idTecnicoResponsavelEndosso == 0) {
          this.usuarioApisul = {
            id: 0,
            nome: "GRUPO APISUL",
            email: "grupo@apisul.com"
          };
        } else {
          this.listaTecnicoResponsavelEndosso = response;
          this.buscarTecnicoResponsavelIdEndosso(idTecnicoResponsavelEndosso);
        }
      }
    },

    buscarTecnicoResponsavelIdEndosso(id) {
      axios
        .get(
          `${process.env.URL_USUARIOMS}/v1/no-auth/buscarTecnicoResponsavelPorId?idTecnicoResponsavel=${id}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response) {
            this.listaTecnicoResponsavelEndosso.push(response.data);
            this.campoTecnicoResponsavelEndosso = id;
          }
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },

    buscarCampoTecnicosResponsaveisEndosso(tratamentoBuscar) {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/buscarTecnicosResponsaveisApolice`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          if (response) {
            if (
              this.campoTecnicoResponsavelEndosso &&
              tratamentoBuscar &&
              this.idTecnicoResponsavelEndosso
            ) {
              this.tratamentoCampoTecnicoResponsavelEndosso(
                this.campoTecnicoResponsavelEndosso,
                response.data
              );
            } else if (
              this.idApolice != undefined &&
              this.idApolice != null &&
              tratamentoBuscar &&
              this.idTecnicoResponsaveEndossolFiltrado
            ) {
              this.tratamentoCampoTecnicoResponsavelEndosso(
                this.idTecnicoResponsavelEndossoFiltrado,
                response.data
              );
            } else {
              this.listaTecnicoResponsavelEndosso = response.data;
              this.campoTecnicoResponsavelEndosso = this.idTecnicoResponsavelEndossoFiltrado;
            }
          }
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },

    corretorResponsavelEndossoSet(id, nome) {
      if (id && nome) {
        this.idCorretorResponsavelEndossoFiltrado = id;
        this.idCorretorResponsavelEndosso = id;
        this.nomeCorretorResponsavelEndosso = nome;
      }
    },

    salvarCorretorResponsavelEndosso(idCorretor, nomeCorretor) {
      const self = this;
      self.modelCorretorResponsavelEndosso.idCorretorResponsavelEndosso = idCorretor;
      self.modelCorretorResponsavelEndosso.nomeCorretorResponsavelEndosso = nomeCorretor;
      self.modelCorretorResponsavelEndosso.tipoEndosso = this.idEndossoRascunhoSalvo
        ? 'ENDOSSORASCUNHO'
        : 'APOLICEREVISAO';
      self.modelCorretorResponsavelEndosso.idEndosso = this.idEndossoRascunhoSalvo
        ? this.idEndossoRascunhoSalvo
        : this.numeroRevisao;
      axios.put(`${process.env.URL_ENDOSSOMS}/v1/atualizarCorretorResponsavelEndosso/${this.idApolice}`, self.modelCorretorResponsavelEndosso, {
          headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
        .then((response) => {
          self.snackbar.sucesso = true;
          self.snackbar.visivel = true;
          self.snackbar.mensagem = 'Corretor responsável do endosso vinculado com sucesso';
        })
        .catch((err) => {
          self.snackbar.visivel = true;
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = err.response.data.message;
        });
      this.corretorResponsavelEndossoSet(idCorretor, nomeCorretor);
    },

    tecnicoResponsavelEndossoSet(id, nome) {
      if (id && nome) {
        this.idTecnicoResponsavelEndossoFiltrado = id;
        this.idTecnicoResponsavelEndosso = id;
        this.nomeTecnicoResponsavelEndosso = nome;
      }
    },

    salvarTecnicoResponsavelEndosso(idTecnicoResponsavelEndosso, nomeTecnicoResponsavelEndosso) {
      const self = this;
      self.modelTecnicoResponsavelEndosso.idTecnicoResponsavelEndosso = idTecnicoResponsavelEndosso;
      self.modelTecnicoResponsavelEndosso.nomeTecnicoResponsavelEndosso = nomeTecnicoResponsavelEndosso;
      self.modelTecnicoResponsavelEndosso.tipoEndosso = this.idEndossoRascunhoSalvo
        ? 'ENDOSSORASCUNHO'
        : 'APOLICEREVISAO';
      self.modelTecnicoResponsavelEndosso.idEndosso = this.idEndossoRascunhoSalvo
        ? this.idEndossoRascunhoSalvo
        : this.numeroRevisao;
      axios.put(`${process.env.URL_ENDOSSOMS}/v1/atualizarTecnicoResponsavelEndosso/${this.idApolice}`, self.modelTecnicoResponsavelEndosso, {
          headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
        .then((response) => {
          self.snackbar.sucesso = true;
          self.snackbar.visivel = true;
          self.snackbar.mensagem = 'Técnico responsável do endosso vinculado com sucesso';
        })
        .catch((err) => {
          self.snackbar.visivel = true;
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = err.response.data.message;
        })
      this.tecnicoResponsavelEndossoSet(idTecnicoResponsavelEndosso, nomeTecnicoResponsavelEndosso)
    },

    buscarUsuariosCampoResponsavel(tratamentoBuscar) {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/buscarUsuariosApolice`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          if (response) {
            if (
              this.campoUsuarioReponsavel &&
              tratamentoBuscar &&
              this.idUsuarioCorretor
            ) {
              this.tratamentoCampoUsuarioResponsavel(
                this.campoUsuarioReponsavel,
                response.data
              );
            } else if (
              this.idApolice != undefined &&
              this.idApolice != null &&
              tratamentoBuscar &&
              this.idUsuarioCorretorFiltrado
            ) {
              this.tratamentoCampoUsuarioResponsavel(
                this.idUsuarioCorretorFiltrado,
                response.data
              );
            } else {
              this.listaUsuariosResponsavel = response.data;
            }
          }
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },

    atualizarInformacoesEndosso() {
      this.$store.commit("formEndosso/setInfoEndosso", {
          idAplicaCondicao: this.idAplicaCondicao,
          idTipoDeProposta: this.idTipoDeProposta,
          apoliceNumero: this.apoliceNumero,
          codigoEndosso: this.codigoEndosso,
          apoliceNumeroProposta: this.apoliceNumeroProposta,
          dataUltimaAtualizacao: this.dataUltimaAtualizacao,
          idTipoEndosso: this.idTipoEndosso,
          dateInicio: this.dateInicio,
          dateFim: this.dateFim,
          diasVigencia: this.diasVigencia,
          idMotivoEndosso: this.idMotivoEndosso,
          textoLivreEndosso: this.textoLivreEndosso,
          apoliceEndereco: this.obterApoliceEndereco(),
          corretagem: this.corretagem,
          apoliceIof: this.apoliceIof,
          premioTotalEndosso: this.premioTotalEndosso,
          valorRestituicao: this.valorRestituicao,
          totalPremio: this.totalPremio,
          idParcelamento: this.idParcelamento,
          idFormaPagamento: this.idFormaPagamento,
          dataPrimeiraParcela: this.dataPrimeiraParcela,
          conteudoPlanilha: this.conteudoPlanilha,
          idRascunhoEndosso: this.idRascunhoEndosso,
          uuidRevisao: this.uuidRevisao,
          naoCalcularItens: this.naoCalcularItens,
          percCondicaoComercial: this.condicaoComercial,
          idTipoCondicao: this.idTipoCondicao,
          idStatusEndosso: this.idStatusEndosso,
          idTipoPessoa: this.idTipoPessoa,
          proponenteCnpj: this.proponenteCnpj,
          proponenteRazaoSocial: this.proponenteRazaoSocial,
          idEndossoRascunhoSalvo: this.idEndossoRascunhoSalvo,
          recalcular: this.recalcular,
          idTecnicoResponsavelEndosso: this.idTecnicoResponsavelEndosso,
          nomeTecnicoResponsavelEndosso: this.nomeTecnicoResponsavelEndosso,
          idCorretorResponsavelEndosso: this.idCorretorResponsavelEndosso,
          nomeCorretorResponsavelEndosso: this.nomeCorretorResponsavelEndosso,
          listaCondicaoComercialEspecial: this.listaCondicaoComercialEspecial,
          listaCondicaoComercialEspecialModificacao: this.listaCondicaoComercialEspecialModificacao
      });
    },

    obterApoliceEndereco() {
      return (this.idTipoEndosso == 5 || this.idTipoEndosso == 6) ? {
          enderecoCep: this.apoliceEndereco.enderecoCep,
          enderecoRua: this.apoliceEndereco.enderecoRua,
          enderecoNumero: this.apoliceEndereco.enderecoNumero,
          enderecoComplemento: this.apoliceEndereco.enderecoComplemento,
          enderecoBairro: this.apoliceEndereco.enderecoBairro,
          enderecoCidade: this.apoliceEndereco.enderecoCidade,
          enderecoUf: this.apoliceEndereco.enderecoUf,
          enderecoTelefone: this.apoliceEndereco.enderecoTelefone,
          enderecoEmail: this.apoliceEndereco.enderecoEmail
      } : {};
    },

    redirecionarPagina() {
      const idApolice = this.idApolice;
      const idTipoEndosso = this.idTipoEndosso;
      const numeroRevisao = this.numeroRevisao;
      const idStatusEndosso = this.idStatusEndosso;
      const idRascunhoEndosso = this.idRascunhoEndosso;
      const idPropostaStatus = this.idPropostaStatus;

      if(idTipoEndosso == 5) {
        this.$router.push(`/GridPrincipal/GridEndossoVeiculoSubstituicao?id=${idApolice}${
          idStatusEndosso ? `&idStatusEndosso=${idStatusEndosso}` : ''
        }&idTipoEndosso=${idTipoEndosso}&idPropostaStatus=${idPropostaStatus}${
          numeroRevisao ? `&numeroRevisao=${numeroRevisao}` : ''
        }`);
      }
      else if (numeroRevisao && idTipoEndosso !== 3) {
        this.$router.push(`/GridPrincipal/GridEndossoVeiculos?id=${idApolice}${
          idStatusEndosso ? `&idStatusEndosso=${idStatusEndosso}` : ''
        }&idTipoEndosso=${idTipoEndosso}&idPropostaStatus=${idPropostaStatus}${
          numeroRevisao ? `&numeroRevisao=${numeroRevisao}` : ''
        }`);
      } else if (numeroRevisao && idTipoEndosso == 3 && idStatusEndosso !== 1 && idStatusEndosso !== 8) {
        this.$router.push(`/GridPrincipal/GridEndossoVeiculos?id=${idApolice}${
          idStatusEndosso ? `&idStatusEndosso=${idStatusEndosso}` : ''
        }&idTipoEndosso=${idTipoEndosso}&idPropostaStatus=${idPropostaStatus}${
          numeroRevisao ? `&numeroRevisao=${numeroRevisao}` : ''
        }`);
      } else if (idRascunhoEndosso) {
        const tipoPagina = this.definirPaginaRedirecionamento(idTipoEndosso);
        this.$router.push(`/GridPrincipal/${tipoPagina}?id=${idApolice}${
          idStatusEndosso ? `&idStatusEndosso=${idStatusEndosso}` : ''
        }&idTipoEndosso=${idTipoEndosso}&idRascunhoEndosso=${idRascunhoEndosso}&idPropostaStatus=${idPropostaStatus}`);
      } else if (idTipoEndosso == 3) {
        this.dadosLocalStore();
        this.$router.push(`/GridPrincipal/GridEndossoVeiculoExclusao?id=${idApolice}${
          idStatusEndosso ? `&idStatusEndosso=${idStatusEndosso}` : ''
        }&idTipoEndosso=${idTipoEndosso}&idPropostaStatus=${idPropostaStatus}${
          numeroRevisao ? `&numeroRevisao=${numeroRevisao}` : ''
        }`);
      } else {
        const tipoPagina = this.definirPaginaRedirecionamento(idTipoEndosso);
        this.$router.push(`/GridPrincipal/${tipoPagina}?id=${idApolice}&idTipoEndosso=${idTipoEndosso}${
          idStatusEndosso ? `&idStatusEndosso=${idStatusEndosso}` : ''
        }&idPropostaStatus=${idPropostaStatus}${
          numeroRevisao ? `&numeroRevisao=${numeroRevisao}` : ''
        }`);
      }
    },

    definirPaginaRedirecionamento(idTipoEndosso) {
      switch (idTipoEndosso) {
        case 3: return "GridEndossoVeiculoExclusao";
        case 5: return "GridEndossoVeiculoSubstituicao";
        case 6: return "GridEndossoVeiculosAlteracao";
        default: return "GridEndossoVeiculos";
      }
    },

    buscaOpcoesTipoVeiculo() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          [
            "catVeiculoList",
          ].forEach((nome) => {
            this.modelosListas[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    adicionarNovaCondicaoComercialEspecial() {
      this.mostrarCamposCondicaoComercialEspecial = true;
      this.listaCondicaoComercialEspecial.push({
        id: null,
        idApolice: null,
        idEndosso: null,
        idEndossoRascunho: null,
        idTipoCondicao: null,
        idAplicaCondicao: null,
        percCondicaoComercial: null,
        listaIdCategoriaVeiculo: []
      })
    },

    removerCondicaoComercialEspecial(index) {
      if (this.listaCondicaoComercialEspecial[index].id !== null) {
        const itemCondicaoComercialEspecialRemovida = this.listaCondicaoComercialEspecial[index];

        this.listaCondicaoComercialEspecial.splice(index, 1);

        if (!this.listaCondicaoComercialEspecialModificacao) {
          this.listaCondicaoComercialEspecialModificacao = [];
        }

        this.listaCondicaoComercialEspecialModificacao.push(itemCondicaoComercialEspecialRemovida);
      } else {
        this.listaCondicaoComercialEspecial.splice(index, 1);
      }
    },

    igualTodosItensCategoriaVeiculo(index) {
      return this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.length === this.modelosListas.catVeiculoList.length
        || this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.length > this.modelosListas.catVeiculoList.length;
    },

    igualUmItemCategoriaVeiculo(index) {
      return (
        this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.length > 0 && !this.igualTodosItensCategoriaVeiculo(index)
      );
    },

    iconeSelecionarTodosCategoriaVeiculo(index) {
      if (this.igualTodosItensCategoriaVeiculo(index)) return "check_box";
      if (this.igualUmItemCategoriaVeiculo(index)) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },

    selecionarTodosItensCategoriaVeiculo(index) {
    	this.$nextTick(() => {
        if (this.igualTodosItensCategoriaVeiculo(index)) {
          this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo = [];
        } else {
          const listagemItensVeiculos = this.modelosListas.catVeiculoList.slice();
          for (var veiculoItem of listagemItensVeiculos) {
            if (!this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.includes(veiculoItem.id)) {
              this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.push(veiculoItem.id);
            }
          }
        }
      });
    },

    buscarListaEndossoCondicaoEspecial() {
      if (this.idApolice > 0) {
        axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/buscarListaEndossoCondicaoEspecial/${this.idApolice}/${this.numeroRevisao}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response.data != null && response.data.length > 0) {
            this.mostrarCamposCondicaoComercialEspecial = true;
            if (this.$route.query.apoliceCopiada) {
              this.listaCondicaoComercialEspecial = response.data.map(item => {
                const { id, idApolice, ...camposRestantes } = item;
                return camposRestantes;
              });
            } else {
              this.listaCondicaoComercialEspecial = response.data;
            }
          } else {
            this.listaCondicaoComercialEspecial = [];
          }
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loaderPagina = false;
        });
      }
    },
  },
};
</script>
<style scoped>
.button-message {
  text-transform: capitalize;
  font-weight: 400;
  font-size: 12px;
}

.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;
  font-weight: bold;
}

.wrapper-bolha-info {
  position: absolute;
  background-color: #aaaaaa;
  width: 400px;
  border-radius: 8px;
  padding: 14px;
  top: -30px;
  right: -312px;
  transition: 0.4s ease-in;
  display: block;
}

.wrapper-bolha-info::before {
  position: absolute;
  content: "";
  width: 0px;
  height: 0px;
  border-top: 10px solid transparent;
  border-right: 10px solid #aaaaaa;
  border-bottom: 10px solid transparent;
  border-left: 10px solid transparent;
  top: 22%;
  left: -18px;
}

.wrapper-bolha-info p {
  color: #fff;
  font-size: 15px;
}

.checkbox-calculo-itens {
  position: relative;
  justify-content: space-between;
  align-items: flex-start;
}

.checkbox-calculo-itens .theme--dark.v-icon {
  color: #aaaaaa;
  display: block;
  width: 20%;
}

.textblack {
  color: #757575;
}

.color {
  background-color: #eaeaea;
}

.headline {
  color: white !important;
}

.btn-remover-condicao-especial {
  color: #00456e;
  border: 2px solid #00466E;
  transition: 0.2s all;
}

.btn-remover-condicao-especial:hover {
  background-color: #A3C4D2;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/InfoEndosso.vue